module.exports = __webpack_public_path__ + "static/img/wslogo.05ef3bc9.png";